module.exports = __webpack_public_path__ + "media/images/front/icon_data-8d5aa00a8bea2ee79269cdf6d83cd2ab.png";